//The 4 reinsurance contract files, shared by the importer and the exporter so both use the same columns

//every file has these, they tie a row back to its contract
export const KEY_COLUMNS = ['Contract ID', 'Eff. Date', 'Division ID'];

//the 4 import files told apart by their column headers
//All 4 are required but Lasers can have no rows
export const FILE_KINDS = [
    {
        name: 'Contract Info',
        headers: ['Type', 'Carrier'],
        columns: [...KEY_COLUMNS, 'Description', 'Policy #', 'Type', 'Status', 'Group ID', 'Carrier', 'Term Date',
            'Reimb. Meth.', 'Cycle', 'Spec. Ded.', 'Spec. Max', 'Spec. Rpt. Thresh.', 'Spec. Rpt. Thresh. Pct',
            'Spec. Thresh. Notify', 'Agg. Spec. Ded.', 'Agg. Max', 'Attach. Min.', 'Attach. Min. Term', 'State Min.',
            'Enrolled By Day', 'Disenrolled By Day', 'Enrollment Baseline', 'Enroll. Change Thresh.',
            'Enroll/Disenroll By On Agg Report', 'Adj. Thresh.', 'Adj. Thresh. Pct', 'Has Aggregate',
            'Spec. Inc. From', 'Spec. Inc. Thru', 'Spec. Paid From', 'Spec. Paid Thru',
            'Agg. Inc. From', 'Agg. Inc. Thru', 'Agg. Paid From', 'Agg. Paid Thru', 'Spec. Ded. Notify Users']
    },
    {
        name: 'Contract Criteria',
        headers: ['Applies To'],
        columns: [...KEY_COLUMNS, 'Applies To', 'Criteria Field', 'From', 'Through', 'Exclude']
    },
    {
        name: 'Contract Factors',
        headers: ['Tier', 'Factor'],
        columns: [...KEY_COLUMNS, 'Tier', 'Plan ID', 'Factor Eff. Date', 'Factor Term Date', 'Factor']
    },
    {
        name: 'Contract Lasers',
        headers: ['Subscriber ID'],
        columns: [...KEY_COLUMNS, 'Subscriber ID', 'Member Seq', 'Spec. Ded.']
    },
];

//columns written to excel as real dates (mm/dd/yyyy)
export const DATE_COLUMNS = ['Eff. Date', 'Term Date', 'Spec. Inc. From', 'Spec. Inc. Thru', 'Spec. Paid From', 'Spec. Paid Thru',
    'Agg. Inc. From', 'Agg. Inc. Thru', 'Agg. Paid From', 'Agg. Paid Thru', 'Factor Eff. Date', 'Factor Term Date'];
